import {omneticApi} from '@dms/api/base';

import {
  GetVehicleRelatedRecordCountApiArg,
  GetVehicleRelatedRecordCountApiArgSchema,
  GetVehicleRelatedRecordCountApiResponse,
  GetVehicleRelatedRecordCountResponseBodySchema,
} from './types';

export const vehicleRelatedRecordCountApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getVehicleRelatedRecordCount: build.query<
      GetVehicleRelatedRecordCountApiResponse,
      GetVehicleRelatedRecordCountApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/related-record-count`,
      }),
      // The consolidated count aggregates several record types. By providing the
      // same cache tags their individual queries already expose, every existing
      // mutation that invalidates those tags refreshes this badge too.
      providesTags: (_result, _error, queryArg) => [
        {type: 'documentsCount', id: queryArg.vehicleId},
        'InterestCount',
        'VehicleTestDrivesV1',
        'BusinessCaseCount',
        {type: 'BusinessCaseCountByVehicle', id: queryArg.vehicleId},
        {type: 'RentalOrder', id: 'CALENDAR'},
      ],
      extraOptions: {
        requestSchema: GetVehicleRelatedRecordCountApiArgSchema,
        responseSchema: GetVehicleRelatedRecordCountResponseBodySchema,
      },
    }),
  }),
  overrideExisting: false,
});

export const {useGetVehicleRelatedRecordCountQuery} = vehicleRelatedRecordCountApi;
